import type { Stage } from "@core/foundation/stage";
import { getQualifiedDomainName } from "@core/foundation/stage";

import type { AnyMcpTools, McpTools } from "./mcp-tool.ts";

const MCP_PATH = "/mcp";

export interface McpServerInfo {
  readonly name: string;
  readonly version: string;
}

export interface McpApi<Domain extends string, Tools> {
  readonly authType: "oauth";
  readonly domain: Domain;
  readonly getOrigin: (stage: Stage) => string;
  readonly getResourceUrl: (stage: Stage) => string;
  readonly path: string;
  readonly scopes: readonly string[];
  readonly serverInfo: McpServerInfo;
  readonly tools: McpTools<Tools>;
}

export type AnyMcpApi = McpApi<string, AnyMcpTools>;

export function mcpApi<Domain extends string, Tools>(
  {
    domain,
    scopes = [],
    serverInfo,
  }: {
    readonly domain: Domain;
    readonly scopes?: readonly string[];
    readonly serverInfo: McpServerInfo;
  },
  tools: McpTools<Tools>,
): McpApi<Domain, Tools> {
  const getOrigin = (stage: Stage): string =>
    `https://${getQualifiedDomainName(domain, stage)}`;

  return {
    authType: "oauth",
    domain,
    getOrigin,
    getResourceUrl: stage => `${getOrigin(stage)}${MCP_PATH}`,
    path: MCP_PATH,
    scopes,
    serverInfo,
    tools,
  };
}
